// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Lgvbe","title":"styles_title__2Rpg6"};